















































































































































import { Channel } from "@/types/group/group";
import { Component, Prop, Vue } from "vue-property-decorator";
import draggable from "vuedraggable";
@Component({
    components: { draggable },
})
export default class ChannelManage extends Vue {
    private communityId: number = parseInt(this.$route.params.community_id);
    private channelList: Channel[] = [];

    async mounted() {
        // this.channelList = await this.$api.getCommunityChannel(
        //     this.communityId
        // );
        //
        // console.log(this.channelList);
    }
}
